/*!
 * DOXXbet SportBox v4.2.8-0 ~ Copyright (c) 2012-2026 DOXXbet, http://www.doxxbet.sk
 */

// Namespace init
main = {};                              // Inicializacne a zakladne funkcie
communication = {
  dataTrackModule: {},                  // Komunikacia s google analytics
  matchtrackerModule: {},               // Komunikacia matchtracker panel
  onboardingTrackModule: {}            // Session logika pre onboarding
};
directives = {
    topTipsDirective: {},               // Direktiva zapasov dna v home
    eventDetailDirective: {},           // Direktiva detailu zapasu
    eventDetailInlineDirective: {},     // Direktiva detailu zapasu v plachte (VG - kone, psy)
    playerTicketsDirective: {},         // Direktiva mojich tiketov ~ hracskych tiketov
    sportsBookDirective: {},            // Direktiva laveho menu ponuky (prematch, live)
    popularSportsbookDirective: {},     // Direktiva laveho menu ponuky (popularne ligy)
    virtualSportsbookDirective: {},     // Direktiva laveho menu ponuky virtualnych hier
    lotterySportsbookDirective: {},     // Direktiva laveho menu ponuky loteriovych hier
    eventsDirective: {},                // Direktivy plachty
    playerBonusDirective: {},           // Direktivy hracskych bonusov
    ticketDetailDirective: {},          // Direktivy detailu tiketu
};
dev = {};                               // Development non-production utility
eventDetail = {                         // Detail zapasu v samostatnom okne
    eventDetailInlineModule: {}         // Detail zapasu v zobrazeny v plachte pod zapasom
};
home = {
    popularLeaguesModule: {},           // Popularne ligy v home
    topTipsModule: {}                   // Top tipy v home
};
modal = {};                             // Modalne okna, tooltipy, univerzalne okna (Okrem detailu zapasu, detailu tiketu)
dialog = {};                            // Dialogove okna 
more = {
    menu: {},                           // Obsluzne funkcie poloziek v burger menu
    search: {},                         // Search kalkulacka - doplnkova funkcia hornej listy
    volume: {},                         // Ovladanie hlasitosti - doplnkova funkcia hornej listy
    asideLoading: {}                    // Loader pre schvalovanie live tiketov a ticketov s timeoutom
};
events = {                              // Zapasy v plachte
    eventsCompetitionModule: {},        // Zapasy v plachte - sutaze
    eventsSignalrModule: {},            // SignalR notifikacie (zmena stavov oddov, tiketu)
};
player = {                              // Login, Logout, BiometryLogin
    playerBonusModule: {},              // Obsluzne funkcie pre hracske bonusy
    playerTickets: {},                  // Tikety prihlaseneho hraca (moje tikety ~ historia tiketov)
    playerFavoritesModule: {},          // Obsluzne funkcie pre oblubene (sporty, ligy, zapasy, ECT)
    playerSettingsModule: {},           // Hracske nastavenia
    incomeSourcesModule: {}             // Obsluzne funkcie pre zdroje prijmov hraca
};
service = {};                           // Dopytovacie funkcie na BE (loadPure, nove services)
shared = {                              // Zdielane funkcie (score, gameparts, ...)
    scrollModule: {}                    // Zdielana funkcia scroll
};
sportsBook = {};                        // Lave menu ponuky pre prematch, live, vysledky (sporty, regiony, ligy)
lottery = {};                           // Obsluzne funkcie pre loteriove hry
virtual = {};                           // Obsluzne funkcie pre virtualne hry
betbuilderAgg = {                       // [Betbuilder Aggregator API] Obsluzne funkcie
    texts: {},                          // [Betbuilder Aggregator API] Texty/preklady
    api: {},                            // [Betbuilder Aggregator API] API komunikacia s backendom
    panel: {},                          // [Betbuilder Aggregator API] Funkcie pre zobrazenie a aktualizaciu Betbuilder panelu a modalu
    signalrModule: {}                   // [Betbuilder Aggregator API] SignalR komunikacia pre aktualizaciu kurzov a stavu
};                     

quickbet = {};                          // Obsluzne funkcie pre quickbety
ticket = {                              // Rozpracovany tiket - zakladne, spolocne funkcie
    ticketCombiModule: {},              // Kombinovany tiket
    ticketEditModule: {},               // Editacia tiketu
    ticketLotteryModule: {},            // Loteriovy tiket
    ticketOddModule: {},                // Jednotlive zapasy na tikete
    ticketPromoModule: {},              // Bonifikacie suvisiace s tiketom (freebet, XXL bonus)
    ticketWinCurrencyModule: {}         // Obsluzne funkcie pre winy (virtualna mena)
};
ticketDetail = {};                      // Detail podaneho tiketu 
stream = {}                             // Stream
